
        <div *ngIf="!(error || e2esEnabled())">
            <sn-auth-working></sn-auth-working>
        </div>
        <div *ngIf="error"><sn-auth-error [error]="error"></sn-auth-error></div>
    